/* eslint-disable react/forbid-prop-types,react/require-default-props */
import React, { Component } from 'react';
import { scrollDispatch } from 'organism-react-scroll-nav';
import ProductsStore from 'stores/Products.store';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import DesktopNavigation from './DesktopNavigation';
import MobileNavigation from './MobileNavigation';

scrollDispatch({
  scrollMargin: 0,
  scrollDelay: 0,
});

@inject('windowStore', 'navigationStore')
@observer
class Navigation extends Component {
    constructor(props) {
    super(props);
    this.content = ProductsStore.content;
  }

  render() {
      const { windowStore, parsedStructure, navigationStore, isSupportProducts } = this.props;

      if (isSupportProducts && !parsedStructure.some(item => item.id === 'report-problem-link'))
      {
          parsedStructure.push({
              id: 'report-problem-link',
              highlighted: true,
              models: [],
              sectionName: 'Zg\u0142o\u015b problem', //encoding problem
              urlSlug: 'https://zonifero.atlassian.net/servicedesk/customer/topic/7f3d783b-22fe-44db-a877-b73ed22d7cb3',
          });
      }
    return (
      windowStore.isOnTablet
        ? (
          <MobileNavigation
            navigationStore={navigationStore}
            parsedStructure={parsedStructure}
          />
        )
        : (
          <DesktopNavigation
            windowStore={windowStore}
            parsedStructure={parsedStructure}
          />
        )
    );
  }
}
Navigation.propTypes = {
  windowStore: PropTypes.object,
  navigationStore: PropTypes.object,
  parsedStructure: PropTypes.array,
  isSupportProducts: PropTypes.bool,
};
Navigation.defaultProps = {
  parsedStructure: [],
  isSupportProducts: false,
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/index.jsx